import { BaseEntity } from '../../base-entity';

export enum StudentScholarshipsStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export interface StudentScholarshipsEntity extends BaseEntity {
  id: number;
  userId: number;
  funderName: string;
  studentScholarshipsStatus: StudentScholarshipsStatus;
  scholarshipSum: number;
  consumeSum: number;
}
